module.exports = __webpack_public_path__ + "img/ResearchHUB Guiding Principles 11 06 2024-7.bd9f036a.png";